import script from "./Salary.vue?vue&type=script&setup=true&lang=js"
export * from "./Salary.vue?vue&type=script&setup=true&lang=js"

import "./Salary.vue?vue&type=style&index=0&id=0c34d549&scoped=true&lang=css"
import "./Salary.vue?vue&type=style&index=1&id=0c34d549&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c34d549"]])

export default __exports__